import React from 'react';
import ChatNotification from './ChatNotification';
import RequestAndProductNotification from './RequestAndProductNotification';

type Props = {
  className?: string,
  type?: 'request' | 'product' | 'chat',
  receivedFrom?: 'string',
  chatText?: 'string',
  viewChat?: Function,
  closeNotification?: Function,
  rightTitle?: string,
  iconName?: string,
};

const Notification = ({
  type,
  className,
  receivedFrom,
  chatText,
  iconName,
  viewChat,
  closeNotification,
  ...restProps
}: Props) => {
  if (type === 'chat') {
    return (
      <ChatNotification
        className={className}
        receivedFrom={receivedFrom}
        chatText={chatText}
        closeNotification={closeNotification}
        viewChat={viewChat}
      />
    );
  }

  return (
    <RequestAndProductNotification
      className={className}
      type={type}
      iconName={iconName}
      rightTitle={restProps.rightTitle}
      closeNotification={closeNotification}
      viewChat={viewChat}
    />
  );
};

Notification.defaultProps = {
  className: '',
  type: 'request',
  iconName: 'bag-16',
};

export default Notification;
